const EventEmitter = require('events');

import {newReq} from "@/core/request";

export class Manual extends EventEmitter {
    constructor(obj) {
        super();
        this._id = null
        this.duration = null;
        this.match = null;
        this.employeeId = null;
        this.start = null;
        this.end = null;
        this.approved = null;
        this.approvedBy = null;
        this.approvedDate = null;

        obj.start = new Date(obj.start || undefined)
        obj.end = new Date(obj.end || undefined)

        Object.assign(this, obj)
    }
}